import React from 'react'
import { equals } from 'ramda'
import FilterIcon from '../../atoms/Icons/Controls/Configure'
import styles from './DataFilters.module.scss'
import Pill from '../../atoms/Pill/Pill'
import DataFiltersMenu from './DataFiltersMenu/DataFiltersMenu'
import { IOption, IFilter } from './DataFilters.types'

interface DataFiltersProps {
  filters: IFilter[]
  onFiltersChanged: (filters: IFilter[]) => void
}

const DataFilters = ({ filters, onFiltersChanged }: DataFiltersProps) => {
  const handleFilterSelect = (filterLabel: string, option: IOption) => {
    const filterOption = filters.find(filter => filter.label === filterLabel)
    if (!filterOption) return

    const newFilter: IFilter = {
      ...filterOption,
      options: filterOption.options.map(fo => ({
        ...fo,
        isActive: fo.label === option.label ? true : fo.isActive,
      })),
    }

    if (equals(newFilter, filterOption)) {
      handleRemoveFilter(filterLabel, option.label)
    } else {
      const newFilters = filters.map(filter => (filter.label === newFilter.label ? newFilter : filter))
      onFiltersChanged(newFilters)
    }
  }

  const activeFiltersLength = filters.flatMap(filter => filter.options.filter(option => option.isActive)).length

  const handleRemoveFilter = (filterLabel: string, optionLabel: string) => {
    const filterOption = filters.find(filter => filter.label === filterLabel)
    if (!filterOption) return

    const newFilter: IFilter = {
      ...filterOption,
      options: filterOption.options.map(fo => ({
        ...fo,
        isActive: fo.label === optionLabel ? false : fo.isActive,
      })),
    }

    const newFilters = filters.map(filter => (filter.label === newFilter.label ? newFilter : filter))
    onFiltersChanged(newFilters)
  }

  return (
    <div className={styles.root}>
      <div className={styles['active-filters-container']}>
        <span>Filters: </span>
        {activeFiltersLength > 0 ? (
          <div className={styles['active-filters']}>
            {filters.flatMap(filter =>
              filter.options
                .filter(option => option.isActive)
                .map((option, index) => (
                  <Pill
                    key={`pill-${index}`}
                    className={styles.pill}
                    onRemove={() => handleRemoveFilter(filter.label, option.label)}
                  >
                    {`${filter.label}: ${option.label}`}
                  </Pill>
                )),
            )}
          </div>
        ) : (
          <>
            Click on the filter button <FilterIcon /> to the right to add filters
          </>
        )}
      </div>
      <DataFiltersMenu filters={filters} onFilterSelect={handleFilterSelect} />
    </div>
  )
}

export default DataFilters
